<template>
    <el-dialog width="480px" v-model="dialogVisible" :close-on-click-modal="true" draggable :show-close="false">
        <el-form :model="form" label-position="right" v-loading="loading">
            <div :class="form.positionSide === constants.SHORT ? 'title red' : 'title green'">{{ title }}</div>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="成交量" label-width="100px">
                        <div class="transamount">{{ form.TransAmount }} U</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="开启" label-width="100px">
                        <el-col :span="12">
                            <el-checkbox v-model="allowTakeProfit" style="width:100px">止盈</el-checkbox>
                        </el-col>
                        <el-col :span="12">
                            <el-checkbox v-model="allowStopLoss" style="width:100px">止损</el-checkbox>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;">
                <el-col :span="24">
                    <el-form-item label="触发类型" label-width="100px">
                        <el-col :span="12">
                            <el-select v-model="form.tpWorkingType" placeholder="止盈" style="width:130px"
                                @change="handleChange('TP')">
                                <el-option label="标记" :value="constants.MARK_PRICE"></el-option>
                                <el-option label="最新" :value="constants.CONTRACT_PRICE"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <el-select v-model="form.slWorkingType" placeholder="止损" style="width:130px"
                                @change="handleChange('SL')">
                                <el-option label="标记" :value="constants.MARK_PRICE"></el-option>
                                <el-option label="最新" :value="constants.CONTRACT_PRICE"></el-option>
                            </el-select>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 20px;">
                <el-col :span="24">
                    <el-form-item label="盈亏目标" label-width="100px">
                        <el-col :span="12">
                            <el-tag type="warning" size="large" style="width:130px">
                                止盈 {{ form.TakeProfit }}%&nbsp;-&nbsp;{{ form.TakeProfitAmount }} U
                            </el-tag>
                        </el-col>
                        <el-col :span="12">
                            <el-tag type="warning" size="large" style="width:130px">
                                止损 {{ form.StopLoss }}%&nbsp;-&nbsp;{{ form.StopLossAmount }} U
                            </el-tag>
                        </el-col>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit()" :loading="loading">确 定</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<style scoped>
.transamount {
    border-radius: 5px;
    background-color: #3a3a3a;
    font-size: 14px;
    color: white;
    height: 30px;
    padding-left: 20px;
    line-height: 30px;
    width: 285px;
}

.title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
}

.amount {
    font-size: 14px;
    font-weight: bold;
}

.green {
    color: #67c23a;
}

.red {
    color: #f56c6c;
}
</style>
<script setup>
import { ref, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import Decimal from 'decimal.js'
import * as constants from '@/utils/binanceConstants'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'
import { Helper } from '@/service'
import Database from '@/service/database'

const systemStore = useSystemStore()
const logStore = useLogStore()
const current = ref(systemStore.currentusymbol)
const dialogVisible = ref(false)
const loading = ref(false)
const allowTakeProfit = ref(true)
const allowStopLoss = ref(true)
const title = ref("")
const form = ref({
    Lever: "",
    TransAmount: "",
    TakeProfit: "",
    TakeProfitAmount: "",
    StopLoss: "",
    StopLossAmount: "",
    tpWorkingType: "",
    slWorkingType: "",
})
const tpId = ref("")
const slId = ref("")


const init = async (data) => {
    dialogVisible.value = true
    form.value = data
    title.value = `${current.value.symbol} ${current.value.binanceConfig.marginType === constants.CROSS ? "全仓" : "逐仓"} ${data.positionSide === constants.LONG ? "开多" : "开空"}  ×${data.Lever}`
    initWorkingType()
}

const submit = async () => {
    try {
        loading.value = true
        let symbol = systemStore.usymbols.find(x => x.symbol === current.value.symbol)

        //获取标记价格
        const rate = await systemStore.publicClient.fundingRate(current.value.symbol)
        let markPx = parseFloat(rate.markPrice)

        let amount = parseFloat(form.value.TransAmount)
        let quantityPrecision = parseFloat(symbol.info.quantityPrecision)    //数量精度
        let pricePrecision = parseFloat(symbol.info.pricePrecision)     // 价格精度

        //数数 = 成交量 ÷ 价格
        let sz = amount / markPx
        //根据精度调整小数
        sz = new Decimal(sz).toDecimalPlaces(quantityPrecision, Decimal.ROUND_FLOOR).toNumber()

        let _obj = {
            symbol: current.value.symbol,
            type: constants.MARKET,
            positionSide: form.value.positionSide,
            side: form.value.positionSide === constants.LONG ? constants.BUY : constants.SELL,
            quantity: sz,
        }

        await systemStore.privateClient.order(_obj)
        ElMessage.success('开仓成功')
        loading.value = false
        dialogVisible.value = false

        //添加止盈止损
        try {
            //获取还未撤销的挂单，如果有先撤销
            let orders = await systemStore.privateClient.openOrders()
            let ordersId = orders.filter(x => x.positionSide === form.value.positionSide).map(e => {
                return e.orderId
            })
            ordersId.forEach(async o => {
                await systemStore.privateClient.cancelOrder(current.value.symbol, o)
            })

            //获取开仓均价
            let result = await systemStore.privateClient.positionsV2()
            result = result.filter(x => Number(x.positionAmt) !== 0)
            let positon = result.find(x => x.symbol === current.value.symbol && x.positionSide === form.value.positionSide && x.leverage === form.value.Lever.toString())
            let entryPrice = parseFloat(positon.entryPrice)

            //计算止盈价格
            let tp = 0
            if (allowTakeProfit.value && form.value.TakeProfit) {
                const takeProfit = new Decimal(form.value.TakeProfit).div(100)
                const entryPriceDecimal = new Decimal(entryPrice)
                const pricePrecisionInt = parseInt(pricePrecision)

                //做多
                if (form.value.positionSide === constants.LONG)
                    tp = entryPriceDecimal.times(new Decimal(1).plus(takeProfit))
                //做空
                if (form.value.positionSide === constants.SHORT)
                    tp = entryPriceDecimal.times(new Decimal(1).minus(takeProfit))

                tp = Math.abs(tp.toDecimalPlaces(pricePrecisionInt, Decimal.ROUND_FLOOR).toNumber())
            }

            //计算止损价格
            let sl = 0
            if (allowStopLoss.value && form.value.StopLoss) {
                const stopLoss = new Decimal(form.value.StopLoss).div(100)
                const entryPriceDecimal = new Decimal(entryPrice)
                const pricePrecisionInt = parseInt(pricePrecision)

                //做多
                if (form.value.positionSide === constants.LONG)
                    sl = entryPriceDecimal.times(new Decimal(1).minus(stopLoss))
                //做空
                if (form.value.positionSide === constants.SHORT)
                    sl = entryPriceDecimal.times(new Decimal(1).plus(stopLoss))
                sl = Math.abs(sl.toDecimalPlaces(pricePrecisionInt, Decimal.ROUND_FLOOR).toNumber())
            }

            if (tp > 0) {
                let _o = {
                    symbol: current.value.symbol,
                    side: form.value.positionSide === constants.LONG ? constants.SELL : constants.BUY,
                    positionSide: form.value.positionSide,
                    algoType: 'CONDITIONAL',
                    type: constants.TAKE_PROFIT_MARKET,
                    triggerPrice: tp,
                    closePosition: true,
                    workingType: form.value.tpWorkingType,
                }
                await systemStore.privateClient.algoOrder(_o)
            }

            if (sl > 0) {
                let _o = {
                    symbol: current.value.symbol,
                    side: form.value.positionSide === constants.LONG ? constants.SELL : constants.BUY,
                    positionSide: form.value.positionSide,
                    algoType: 'CONDITIONAL',
                    type: constants.STOP_MARKET,
                    triggerPrice: sl,
                    closePosition: true,
                    workingType: form.value.slWorkingType,
                }
                await systemStore.privateClient.algoOrder(_o)
            }
        } catch (error) {
            ElMessage.error('添加止盈止损失败' + error)
            logStore.addLog({
                title: '添加止盈止损失败',
                level: 'error',
                message: error
            })
        }
    } catch (error) {
        ElMessage.error('开仓失败' + error)
        loading.value = false
        logStore.addLog({
            title: '开仓失败',
            level: 'error',
            message: error
        })
    }
}

const initWorkingType = async () => {
    let workingTypes = await Database.select('WorkingType')
    let tp = workingTypes.find(x => x.Name == 'TP' && x.Platform == 'BINANCE')
    let sl = workingTypes.find(x => x.Name == 'SL' && x.Platform == 'BINANCE')

    tpId.value = tp ? tp.Id : Helper.NewId()
    slId.value = sl ? sl.Id : Helper.NewId()

    if (!tp) {
        Database.insert(
            "WorkingType",
            {
                Id: tpId.value,
                Platform: "BINANCE",
                Name: "TP",
                Type: constants.MARK_PRICE
            }
        )
        tp = { Type: constants.MARK_PRICE }
    }

    if (!sl) {
        Database.insert(
            "WorkingType",
            {
                Id: slId.value,
                Platform: "BINANCE",
                Name: "SL",
                Type: constants.MARK_PRICE
            }
        )
        sl = { Type: constants.MARK_PRICE }
    }

    form.value.tpWorkingType = tp.Type
    form.value.slWorkingType = sl.Type
}

const handleChange = async (type) => {
    if (type === "TP") {
        await Database.insert('WorkingType', {
            Id: tpId.value,
            Platform: "BINANCE",
            Name: "TP",
            Type: form.value.tpWorkingType
        })
    }

    if (type === "SL") {
        await Database.insert('WorkingType', {
            Id: slId.value,
            Platform: "BINANCE",
            Name: "SL",
            Type: form.value.slWorkingType
        })
    }
}


defineExpose({ init })

</script>